<template>
  <div class="user-info">
    <div class="hour">
      {{ time }}
    </div>
    <div class="account-card">
      <div class="user">
        <div class="identity-row">
          <p class="name">{{ trainer.firstName }}</p>
          <span class="role-pill">{{ roleLabel }}</span>
        </div>
        <button class="logout" type="button" @click="logout">
          <svg class="logout-icon" viewBox="0 0 24 24"><path d="M10 17l5-5-5-5"/><path d="M15 12H3"/><path d="M21 19V5a2 2 0 0 0-2-2h-5"/><path d="M14 21h5a2 2 0 0 0 2-2"/></svg>
          Log out
        </button>
      </div>
      <img :src="userPicture" alt="User Picture">
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { clearRememberMeToken } from '@/utils/rememberMeAuth'
import { getUserRoles, isAdminAccessAllowed } from '@/utils/adminAccess'

export default {
  name: 'user-info',
  data: () => ({
    userPicture: 'https://randomuser.me/api/portraits/thumb/men/10.jpg',
    time: ''
  }),
  computed: {
    trainer () {
      return this.$store.getters['Trainer/trainer']
    },
    roleLabel () {
      const user = this.$auth && this.$auth.user ? this.$auth.user() : null
      const roles = [
        ...getUserRoles(user),
        ...getUserRoles(this.trainer),
        ...getUserRoles(this.trainer && this.trainer.user ? this.trainer.user : null)
      ]

      if (isAdminAccessAllowed(user, this.trainer)) {
        return 'ADMIN'
      }

      if (roles.length) {
        return roles[0].replace(/^ROLE_/, '').replace(/_/g, ' ')
      }

      return 'USER'
    }
  },
  methods: {
    logout () {
      clearRememberMeToken()
      this.$auth.logout({redirect: '/login'})
    }
  },
  mounted () {
    setInterval(() => {
      this.time = moment().format('LT')
    }, 1000)
  },
  watch: {
    trainer () {
      if(this.trainer.photoUrl){
        this.userPicture = this.trainer.photoUrl
      }
      if(this.trainer.user.imageUrl){
        this.userPicture = this.trainer.user.imageUrl
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  .user-info
    display flex
    align-items center
    justify-content flex-end
    gap 14px

    .hour
      color rgba(255,255,255,0.82)
      flex 0 0 auto
      font-size 11px
      font-weight 700
      line-height 1
      min-width 54px
      text-align right

    .account-card
      display flex
      align-items center
      gap 9px
      min-height 40px
      padding-left 14px
      border-left 1px solid rgba(255,255,255,0.22)

    .user
      display flex
      flex-direction column
      align-items flex-end
      gap 4px
      min-width 0

      .identity-row
        display flex
        align-items center
        justify-content flex-end
        gap 7px

      .name
        color #fff
        font-size 13px
        font-weight 700
        line-height 1.1
        margin 0
        max-width 112px
        overflow hidden
        text-overflow ellipsis
        white-space nowrap

      .role-pill
        color rgba(255,255,255,0.72)
        font-size 9px
        font-weight 700
        letter-spacing .08em
        line-height 1
        text-transform uppercase

      .logout
        align-items center
        background transparent
        border 0
        color rgba(255,255,255,0.78)
        cursor pointer
        display inline-flex
        font-size 10px
        font-weight 600
        gap 4px
        line-height 1
        margin 0
        padding 0
        text-decoration none

        &:hover
          color #fff

      .logout-icon
        fill none
        height 12px
        stroke currentColor
        stroke-linecap round
        stroke-linejoin round
        stroke-width 1.8
        width 12px

    img
      border 1px solid rgba(255,255,255,0.42)
      border-radius 999px
      box-shadow 0 4px 12px rgba(0,0,0,0.16)
      flex 0 0 auto
      height 34px
      object-fit cover
      width 34px
</style>



// WEBPACK FOOTER //
// UserInfo.vue?4719e372